import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import BtnSend from '../../components/btnSend/BtnSend.js';
import { BsFillPersonFill, BsEnvelopeFill } from 'react-icons/bs';
import { AiOutlineMessage } from 'react-icons/ai';
import './contactForm.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ContactForm = () => {
  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        process.env.REACT_APP_SERVICE_ID,
        process.env.REACT_APP_TEMPLATE_ID,
        form.current,
        process.env.REACT_APP_PUBLIC_KEY
      )
      .then(
        (result) => {
          toast.success('Message sent! 📧', {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
        },
        (error) => {
          toast.error(`We couldn't send your message! 📪`, {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
        }
      );
  };
  return (
    <>
      <form ref={form} onSubmit={sendEmail} action="">
        <input type="text" name="user_name" placeholder="Fullname" />
        <div className="formIcon">
          <BsFillPersonFill />
        </div>
        <input type="text" name="user_email" placeholder="Email" />
        <div className="formIcon">
          <BsEnvelopeFill />
        </div>
        <textarea type="text" name="message" placeholder="Message.." />
        <div className="formIcon formIconMessage">
          <AiOutlineMessage />
        </div>
        <BtnSend />
      </form>
      <ToastContainer />
    </>
  );
};

export default ContactForm;
